import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Schedule from './pages/Schedule';
import Accommodations from './pages/Accommodations';
import FAQs from './pages/FAQs';
// import RSVP from './pages/RSVP';
import RSVPClosed from './pages/RSVPClosed';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/accommodations" element={<Accommodations />} />
        <Route path="/faqs" element={<FAQs />} />
        {/* <Route path="/rsvp" element={<RSVP />} /> */}
        <Route path="/rsvp" element={<RSVPClosed />} />
      </Routes>
    </Router>
  );
}

export default App;
